import * as React from 'react';
import { Box, Paper } from '@mui/material';
import { RecordContextProvider, useListContext } from 'react-admin';

import { SupplierCard } from './SupplierCard';
import { SupplierEmpty } from './SupplierEmpty';
import { Supplier } from '../types';

const times = (nbChildren: number, fn: (key: number) => any) =>
    Array.from({ length: nbChildren }, (_, key) => fn(key));

const LoadingGridList = () => (
    <Box display="flex" flexWrap="wrap" width={1008} gap={1}>
        {times(15, key => (
            <Paper
                sx={{
                    height: 228,
                    width: 220,
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: 'grey[200]',
                }}
                key={key}
            />
        ))}
    </Box>
);

const LoadedGridList = () => {
    const { data, error, filterValues, isPending } = useListContext<Supplier>();

    if (isPending || error) return null;

    const hasFilters = filterValues && Object.keys(filterValues).length > 0;

    if (!data?.length) {
        return (
            <SupplierEmpty
                inline
                subtitle={
                    hasFilters
                        ? 'Ajuste os filtros para encontrar fornecedores.'
                        : undefined
                }
                showActions={!hasFilters}
            />
        );
    }

    return (
        <Box
            width="100%"
            gap={1}
            display="grid"
            gridTemplateColumns="repeat(auto-fill, minmax(210px, 1fr))"
        >
            {data.map(record => (
                <RecordContextProvider key={record.id} value={record}>
                    <SupplierCard />
                </RecordContextProvider>
            ))}
        </Box>
    );
};

export const ImageList = () => {
    const { isPending } = useListContext();
    return isPending ? <LoadingGridList /> : <LoadedGridList />;
};
